import { formatImgStyle } from './formatImgStyle';
import { formatImgSrc } from './formatImgSrc';

/**
 * 注意是三倍图尺寸
 * 如果要占满屏幕,请用formatFullWidthBgStyle
 */
export function formatBackgroundImageStyle(
    style = {},
    { imgWidth, imgHeight, imgUrl } = {},
    times = 3
) {
    return Object.assign(
        style,
        formatImgStyle(
            {
                backgroundImage: `url(${formatImgSrc({
                    imgWidth,
                    imgHeight,
                    imgUrl,
                })})`,
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
            },
            {
                imgWidth,
                imgHeight,
                imgUrl,
            },
            times
        )
    );
}
